'use client';

import Grid from '@enlighten/design-system/dist/Grid';
import IconButton from '@enlighten/design-system/dist/IconButton';
import Stack from '@enlighten/design-system/dist/Stack';
import Typography from '@enlighten/design-system/dist/Typography';
import ChevronLeftSharp from '@mui/icons-material/ChevronLeftSharp';
import ChevronRightSharp from '@mui/icons-material/ChevronRightSharp';
import Image from 'next/image';
import { Fragment, useRef } from 'react';
import Slider from 'react-slick';

import CarouselImg1Pc from '@/assets/images/pages/en/about/carousel-img-1.png';
import CarouselImg1Mobile from '@/assets/images/pages/en/about/carousel-img-1-m.png';
import CarouselImg2Pc from '@/assets/images/pages/en/about/carousel-img-2.png';
import CarouselImg2Mobile from '@/assets/images/pages/en/about/carousel-img-2-m.png';
import CarouselImg3Pc from '@/assets/images/pages/en/about/carousel-img-3.png';
import CarouselImg3Mobile from '@/assets/images/pages/en/about/carousel-img-3-m.png';
import CarouselImg4Pc from '@/assets/images/pages/en/about/carousel-img-4.png';
import CarouselImg4Mobile from '@/assets/images/pages/en/about/carousel-img-4-m.png';
import CarouselImg5Pc from '@/assets/images/pages/en/about/carousel-img-5.png';
import CarouselImg5Mobile from '@/assets/images/pages/en/about/carousel-img-5-m.png';
import ObserveView from '@/components/pages/company/ObserveView';

const images = [
	{
		pc: CarouselImg1Pc,
		mobile: CarouselImg1Mobile,
	},
	{
		pc: CarouselImg2Pc,
		mobile: CarouselImg2Mobile,
	},
	{
		pc: CarouselImg3Pc,
		mobile: CarouselImg3Mobile,
	},
	{
		pc: CarouselImg4Pc,
		mobile: CarouselImg4Mobile,
	},
	{
		pc: CarouselImg5Pc,
		mobile: CarouselImg5Mobile,
	},
];

export default function Awards() {
	const carouselRef = useRef<Slider>(null);

	return (
		<Stack
			width="100%"
			maxWidth={1440}
			padding={{ xs: '60px 24px', md: '120px 24px 90px' }}
			sx={{
				'& img': {
					width: '100%',
					height: 'auto',
				},
			}}
		>
			<ObserveView justifyContent={{ xs: 'center', md: 'space-between' }} alignItems="center" marginBottom={{ xs: 5, md: 6 }}>
				<Typography
					fontSize={{ xs: 24, md: 48 }}
					fontWeight={700}
					textAlign={{ xs: 'center', md: 'left' }}
					letterSpacing={-0.1}
					color="common.white"
					sx={{
						'& i': {
							fontSize: { xs: 26, md: 54 },
							color: '#7F3FFF',
						},
					}}
				>
					{'Clean Tech '}
					<i>Awards</i>
				</Typography>
				<Grid
					display={{ xs: 'none', md: 'flex' }}
					sx={{
						'.MuiIconButton-root': {
							padding: 0,
							'&.Mui-disabled': {
								opacity: 0.3,
							},
							'.MuiSvgIcon-root': {
								color: 'common.white',
							},
						},
					}}
				>
					<IconButton
						title="prev"
						onClick={() => {
							carouselRef.current?.slickPrev();
						}}
					>
						<ChevronLeftSharp fontSize="large" />
					</IconButton>
					<IconButton
						title="next"
						onClick={() => {
							carouselRef.current?.slickNext();
						}}
					>
						<ChevronRightSharp fontSize="large" />
					</IconButton>
				</Grid>
			</ObserveView>
			<Slider ref={carouselRef} swipe={false} arrows={false} waitForAnimate={false} autoplay autoplaySpeed={5000}>
				{images.map(({ pc, mobile }, i) => (
					<Fragment key={i}>
						<Grid display={{ xs: 'none', md: 'block' }} container borderRadius={5} overflow="hidden">
							<Image src={pc} alt={`image ${i}`} />
						</Grid>
						<Grid display={{ xs: 'block', md: 'none' }} container borderRadius={4} overflow="hidden">
							<Image src={mobile} alt={`image ${i}`} />
						</Grid>
					</Fragment>
				))}
			</Slider>
			<Grid
				display={{ xs: 'flex', md: 'none' }}
				container
				justifyContent="center"
				alignItems="center"
				gap={2}
				width="100%"
				marginTop="20px"
				sx={{
					'.MuiIconButton-root': {
						width: 40,
						height: 40,
						borderWidth: 2,
						borderStyle: 'solid',
						borderColor: 'common.white',
						borderRadius: 99,
						padding: 0,
						'&.Mui-disabled': {
							opacity: 0.3,
						},
						'.MuiSvgIcon-root': {
							color: 'common.white',
						},
					},
				}}
			>
				<IconButton
					title="prev"
					onClick={() => {
						carouselRef.current?.slickPrev();
					}}
				>
					<ChevronLeftSharp fontSize="large" />
				</IconButton>
				<IconButton
					title="next"
					onClick={() => {
						carouselRef.current?.slickNext();
					}}
				>
					<ChevronRightSharp fontSize="large" />
				</IconButton>
			</Grid>
		</Stack>
	);
}
